/**
 * Handles Delta Chrome extension which inject style that conflict with existing classes
 */
export function handleDeltaExtension() {
    if (!isChrome()) return;

    const headNode = document.querySelector('head');
    const config = { attributes: false, childList: true, subtree: false };

    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                if (mutation.addedNodes[0]?.id === 'cartera-style-wrapper') {
                    cleanDeltaStyling();
                    console.warn('cartera styling removed', mutation);
                    observer.disconnect();
                }
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(headNode, config);
}

function cleanDeltaStyling() {
    document.querySelector('#cartera-style-wrapper')?.remove();
}

function isChrome() {
    return navigator.userAgent.includes('Chrome');
}
